<template>
    <Multiselect
        ref="Multiselect"
        :options="options"
        :loading="loading"
        :placeholder="$t('categories')"
        :selected-options-label="$t('selectedCategories')"
        searchable
        :group-label="isGrouped ? 'group' : undefined"
        :group-values="isGrouped ? 'categories' : undefined"
        track-by="id"
        label="name"
        select-label=""
        show-checkboxes
        show-selected
        multiple
        :close-on-select="false"
        :clear-on-select="false"
        class="width-200"
        group-select
        preselect-all
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>



<script>
    import sortBy from 'lodash/sortBy';
    import Multiselect from './Multiselect.vue';

    export default {
        name: 'MultiselectProducerProductCategories',
        components: {
            Multiselect,
        },
        props: {
            top: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                requestProducerProductCategories: this.$req('space/ProducerProductCategories'),
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            loading() {
                return this.requestProducerProductCategories.getLoading();
            },
            categories() {
                return sortBy(this.requestProducerProductCategories.getData() || [], 'name');
            },
            isGrouped() {
                return !!this.top.length;
            },
            topCategories() {
                return this.categories.filter(item => this.top.includes(item.id));
            },
            otherCategories() {
                return this.categories.filter(item => !this.top.includes(item.id));
            },
            options() {
                if (this.isGrouped) {
                    return [
                        {
                            group: `Top ${this.topCategories.length}`,
                            categories: this.topCategories,
                        },
                        {
                            group: this.$t('others'),
                            categories: this.otherCategories,
                        },
                    ];
                }
                return this.categories;
            },
        },
        watch: {
            loading() {
                this.$emit('loading', this.loading);
            },
            spaceId: {
                immediate: true,
                handler: 'fetchCategories',
            },
        },
        methods: {
            fetchCategories() {
                return this.requestProducerProductCategories.get(this.spaceId);
            },
        },
    };
</script>
